export const ROOT_URL = "https://api.navitia.io/v1/";
export const ENDPOINT = "places_nearby";
export const FILTERS = "depth=3&disable_disruption=true";
export const VELIB_API = "https://opendata.paris.fr/api/records/1.0/search/?dataset=velib-emplacement-des-stations";
export const DEFAULT_COORDS = [48.856578, 2.351828];
